export const SECTORS = [
  {
    id: "ges",
    title: "Güneş Paneli (GES)",
    category: "Enerji",
    image: "https://images.pexels.com/photos/8853509/pexels-photo-8853509.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    summary:
      "50 kWp ve üzeri tüm GES tesislerinde TSE standartlarına uygun zorunlu termal kontrol.",
    bullets: [
      "Hot-spot, hücre arızası ve bypass diyot hatalarının tespiti",
      "Otel, AVM ve endüstriyel çatı GES sistemleri için zorunlu güvenlik",
      "Yılda en az 2 kez yasal termal kontrol uyumluluğu",
    ],
    metric: { value: "50 kWp+", label: "Yasal eşik" },
  },
  {
    id: "uretim",
    title: "Üretim Tesisleri",
    category: "Endüstri",
    image:
      "https://images.unsplash.com/photo-1720036236697-018370867320?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwyfHxkYXJrJTIwZmFjdG9yeSUyMG1hY2hpbmVyeXxlbnwwfHx8fDE3ODE0NTU1NDh8MA&ixlib=rb-4.1.0&q=85",
    summary:
      "Elektrik panoları, motor kontrol merkezleri ve güç dağıtım üniteleri için sürekli termal izleme.",
    bullets: [
      "Ark ve aşırı yüklenme kaynaklı yangınların önlenmesi",
      "Paketleme ve üretim hattı anomali tespiti",
      "Tehlikeli malzeme bölgelerinde 7/24 izleme",
    ],
    metric: { value: "%70-85", label: "Plansız duruş azalması" },
  },
  {
    id: "depolama",
    title: "Depolama & Lojistik",
    category: "Lojistik",
    image:
      "https://images.pexels.com/photos/37730212/pexels-photo-37730212.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    summary:
      "Geniş depo alanlarında sıcaklık haritalama ve dumandan önce yangın tespiti.",
    bullets: [
      "Yüksek raflarda görüş engeli olmadan tarama",
      "Forklift egzozu gibi rutin ısı kaynaklarını filtreleme",
      "Bölgesel alarm ve entegre sprinkler aktivasyonu",
    ],
    metric: { value: "24/7", label: "Otomatik tarama" },
  },
  {
    id: "atik",
    title: "Atık Yönetimi & Geri Dönüşüm",
    category: "Çevre",
    image:
      "https://images.unsplash.com/photo-1604187351574-c75ca79f5807?auto=format&fit=crop&w=940&q=80",
    summary:
      "Atık yığınlarında kendiliğinden yanma, kimyasal reaksiyon ve sıcak partikül erken tespiti.",
    bullets: [
      "Konveyör bantları ve işleme ünitelerinde sürekli tarama",
      "Metan gazı salınımının termal tespiti",
      "Çevre kirliliğinin hızlı müdahale ile önlenmesi",
    ],
    metric: { value: "0", label: "Kesinti hedefi" },
  },
  {
    id: "tunel",
    title: "Otoyol & Tünel",
    category: "Ulaşım",
    image:
      "https://images.unsplash.com/photo-1545262810-77515befe149?auto=format&fit=crop&w=940&q=80",
    summary:
      "Tünellerde araç yangınlarının 10 saniye içinde tespiti, ters yön ve duran araç alarmı.",
    bullets: [
      "Havalandırma, aydınlatma ve tahliye protokolleriyle entegrasyon",
      "Hava koşullarından etkilenmeyen 7/24 görüş",
      "Trafik kontrol merkezine otomatik bildirim",
    ],
    metric: { value: "10 sn", label: "Yangın tespit süresi" },
  },
  {
    id: "orman",
    title: "Orman Yangınları",
    category: "Doğa",
    image:
      "https://images.unsplash.com/photo-1511027643875-5cbb0439c8f1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwxfHxmb3Jlc3QlMjBmaXJlfGVufDB8fHx8MTc4MTQ1NTU1M3ww&ixlib=rb-4.1.0&q=85",
    summary:
      "Pan-tilt-zoom termal kameralar ile 15 km'ye kadar mesafede ısınma aşamasında tespit.",
    bullets: [
      "GPS koordinatlı otomatik alarm sistemi",
      "Rüzgar, nem, sıcaklık sensörleriyle yayılma modeli",
      "İtfaiye ekiplerinin optimum yönlendirilmesi",
    ],
    metric: { value: "15 km", label: "Tespit menzili" },
  },
  {
    id: "otel",
    title: "Otel & Konaklama",
    category: "Turizm",
    image:
      "https://images.unsplash.com/photo-1537572263231-4314a30d444f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwxfHxob3RlbCUyMGJ1aWxkaW5nJTIwbmlnaHR8ZW58MHx8fHwxNzgxNDU1NTYxfDA&ixlib=rb-4.1.0&q=85",
    summary:
      "Mutfak, çamaşırhane, kazan dairesi ve elektrik odaları için kritik alan izleme.",
    bullets: [
      "Mevcut yangın alarm sistemleriyle entegrasyon",
      "Misafir odalarında sigara dumanı algılama",
      "SPA, wellness ve konferans salonları için güvenlik",
    ],
    metric: { value: "0 hasar", label: "İtibar koruması" },
  },
  {
    id: "sera",
    title: "Sera & Bitkisel Tarım",
    category: "Tarım",
    image:
      "https://images.unsplash.com/photo-1585320806297-9794b3e4eeae?auto=format&fit=crop&w=940&q=80",
    summary:
      "Bitki yaprak sıcaklığı, ısıtma sistemi ve mikroklim haritalama ile bütünsel sera termal yönetimi.",
    bullets: [
      "Bitki su stresi & hastalık erken tespiti — yaprak sıcaklığından semptom öncesi anomali algılama",
      "Isıtma sistemi (boyler, sıcak su boruları, jeotermal hat) verim ve kaçak takibi",
      "Don önleme — kritik eşik altında perde, fan ve ısıtıcı otomatik tetiklenir",
      "Sulama optimizasyonu: kuru zon ve damlatma tıkanıklıklarının ısı farkıyla tespiti",
    ],
    metric: { value: "+%25", label: "Verim artışı potansiyeli" },
  },
];

export const SOLUTIONS = [
  {
    id: "termal",
    code: "01",
    title: "Akıllı Termal Algılama",
    sub: "Yapay Zeka Destekli Erken Uyarı",
    body:
      "Çift kamera teknolojisi: 4MP optik + 160×120 piksel termal sensör. -20°C ile +150°C arasında hassas ölçüm. Optik ve termal görüntülerin senkronize analizi ile yanlış alarm oranı minimumda, gerçek tehdit tespiti maksimumda.",
    tags: ["4MP Optik", "160×120 Termal", "-20°C / +150°C"],
  },
  {
    id: "ai",
    code: "02",
    title: "Yapay Zeka ile Proaktif Koruma",
    sub: "21 Farklı Kural Tanımlama",
    body:
      "Gelişmiş yapay zeka algoritmaları normal operasyon sıcaklıklarını öğrenerek anormal ısı artışlarını anında tespit eder. Trend analizi, makine öğrenmesi ve historik veri ile her ekipman için özel bakım takvimi.",
    tags: ["ML", "Anomali Tespiti", "21 Kural"],
  },
  {
    id: "mudahale",
    code: "03",
    title: "Entegre Müdahale Sistemi",
    sub: "Saniyeler İçinde Otomatik Aksiyon",
    body:
      "Selenoid vana kontrolü ile otomatik sprinkler aktivasyonu, SMS ve e-posta ile çoklu bildirim, PLC/SCADA sistemlerine sorunsuz entegrasyon. 7/24 uzaktan izleme ve kontrol imkanı.",
    tags: ["Sprinkler", "SMS/Mail", "PLC/SCADA"],
  },
  {
    id: "bakim",
    code: "04",
    title: "Kestirimci Bakım",
    sub: "Arızaları Oluşmadan Tespit Edin",
    body:
      "Elektrik motorlarında aşırı ısınma, rulman ve mil yataklarında sürtünme kaynaklı sıcaklık artışları saniyeler içinde algılanır. Plansız duruşlarda %70-85 azalma, bakım maliyetlerinde %40'a varan tasarruf.",
    tags: ["%70-85 ↓ Duruş", "%40 ↓ Bakım", "%30-50 ↑ Ömür"],
  },
  {
    id: "entegrasyon",
    code: "05",
    title: "Sistem Entegrasyonu",
    sub: "Mevcut Altyapınıza Sorunsuz Bağlantı",
    body:
      "Endüstri standartı protokoller: Modbus TCP/IP, OPC UA, MQTT, REST API desteği. PLC, SCADA, BMS ve ERP sistemleriyle haberleşir. Çok katmanlı bildirim: SMS, e-posta, mobil push, sesli arama.",
    tags: ["Modbus TCP/IP", "OPC UA", "MQTT", "REST API"],
  },
  {
    id: "bulut",
    code: "06",
    title: "Bulut Platform & Uzaktan Erişim",
    sub: "Her Yerden, Her Cihazdan",
    body:
      "Güvenli bulut altyapısı ile her yerden erişim. iOS & Android mobil uygulamalar, gerçek zamanlı dashboard, canlı görüntü, yapay zeka destekli anomali tespiti. Multi-tenant mimari ile çoklu tesis yönetimi.",
    tags: ["iOS/Android", "Live Dashboard", "Multi-tenant"],
  },
];

export const STATS_2025 = [
  { value: "4.273", label: "Fabrika yangını (2025)", sub: "Toplam 6.800 yangının %63'ü" },
  { value: "₺513.4M", label: "Sigorta hasar ödemesi", sub: "Milyar TL — tarihi rekor" },
  { value: "%66", label: "Elektriksel kıvılcımdan", sub: "Termal ile önlenebilir" },
];

export const STATS_2024 = STATS_2025;

export const VALUE_PROPS = [
  { code: "01", title: "Anlık İzleme", desc: "7/24 kesintisiz termal tarama ve canlı görüntü akışı." },
  { code: "02", title: "Yapay Zeka Analizi", desc: "Normal operasyonu öğrenir, anomaliyi saniyeler içinde tespit eder." },
  { code: "03", title: "SMS & Mail Uyarı", desc: "Çok katmanlı bildirim — kritik durum doğru kişiye anında ulaşır." },
  { code: "04", title: "Önleyici Tedbirler", desc: "Sprinkler, havalandırma ve PLC ile otomatik müdahale." },
];
